import PropTypes from 'prop-types';
import { InlineFlex, HelperText } from '@cof/plastic-components';

import { useBrand } from '../../BrandContext';
import partners from '../../partners';
import CheckedLabel from '../CheckedLabel/CheckedLabel';
import Label from '../Label';
import Legend from '../Legend';

export const LabelSection = ({ label, id, labelVariant, displayTick, as = 'label', ...props }: any) => {
    const allowedAs = ['label', 'legend'];
    if (!allowedAs.includes(as)) {
        throw new Error(`Invalid 'as' prop. Expected one of ${allowedAs.join(', ')}, but got ${as}`);
    }

    const Base = (
        <CheckedLabel isSmall={labelVariant === 'small'} isVisible={displayTick} data-qm-allow>
            <InlineFlex alignItems="center" data-qm-allow>
                {label}
            </InlineFlex>
        </CheckedLabel>
    );
    if (label)
        return as === 'label' ? (
            <Label variant={labelVariant} data-qa-id={`${id}-label`} htmlFor={id} {...props} data-qm-allow>
                {Base}
            </Label>
        ) : (
            <Legend variant={labelVariant} id={id} {...props} data-qm-allow>
                {Base}
            </Legend>
        );
    return null;
};

export const DescriptionSection = ({ description, id }: any) => {
    const brand = useBrand();
    const thinkMoney = brand === partners.THINKMONEY;
    if (description)
        return (
            <HelperText
                id={`${id}-helper-text`}
                data-qa-id={`${id}-description`}
                // @ts-expect-error TS2322: Type ' children: any; "data-qm-allow": true; fontWeight?: number | undefined; id: string; "data-qa-i
                mt="xs"
                {...(thinkMoney && {
                    fontWeight: 500
                })}
                data-qm-allow
            >
                {description}
            </HelperText>
        );
    return null;
};

LabelSection.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    labelVariant: PropTypes.string,
    displayTick: PropTypes.bool,
    as: PropTypes.oneOf(['label', 'legend'])
};

DescriptionSection.propTypes = {
    id: PropTypes.string.isRequired,
    description: PropTypes.string,
    thinkMoney: PropTypes.bool
};
